import { render, staticRenderFns } from "./VibrationClassificationTable.vue?vue&type=template&id=3b037961&scoped=true"
import script from "./VibrationClassificationTable.vue?vue&type=script&lang=js"
export * from "./VibrationClassificationTable.vue?vue&type=script&lang=js"
import style0 from "./VibrationClassificationTable.vue?vue&type=style&index=0&id=3b037961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b037961",
  null
  
)

export default component.exports